
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/ai-ad-agreement",
      function () {
        return require("private-next-pages/us/ai-ad-agreement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/ai-ad-agreement"])
      });
    }
  